<template>
  <div class="page-qinggong-edit">
    <div class="header">
      <h1 v-if="pageType=='add'">新增藏品</h1>
      <h1 v-if="pageType=='edit'">编辑藏品</h1>
      <h1 v-if="pageType=='detail'">查看藏品</h1>
    </div>

    <div class="tabs">
      <div class="tab-item" :class="{'active': item.value === activeTab}" v-for="(item, index) in tabList" :key="index" @click="changeTab(item)">
        <p>{{item.name}}</p>
      </div>
    </div>
  
    <!-- <div class="sch-box">
      <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" accept="image/*" :data="configData"
        :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
        v-if="pageType!=='detail'">
        <img v-if="imgUrl" style="height:150px;width:100%;object-fit:contain;" :src="imgUrl" class="avatar">
        <div v-else>
          <i class="el-icon-plus avatar-uploader-icon"></i>
          <div class="el-upload__text">上传图片</div>
        </div>
      </el-upload>

      <div class="pic-box" v-if="pageType==='detail'">
        <img :src="imgUrl" alt="">
      </div>
    </div> -->

    <div class="wrap" v-show="activeTab==='1'">
      <!-- <div class="res">
        <h2>素材信息</h2>
      </div> -->

      <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="藏品编号 :" prop="collectCode">
              <el-input v-model="form.collectCode" placeholder="请输入"
                :disabled="pageType==='detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="藏品名称 :" prop="collectName">
              <el-input v-model="form.collectName" placeholder="请输入"
                :disabled="pageType==='detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="藏品类型 :" prop="collectType">
              <el-select clearable v-model="form.collectType" placeholder="请选择" style="height: 100%;">
                <el-option v-for="item in typeList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="总登记号 :" prop="signCode">
              <el-input v-model="form.signCode" placeholder="请输入"
                :disabled="pageType==='detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="分类号 :" prop="typeCode">
              <el-input v-model="form.typeCode" placeholder="请输入"
                :disabled="pageType==='detail'" @change="handleChange"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="级别 :" prop="collectLevel">
              <el-select clearable v-model="form.collectLevel" placeholder="请选择">
                <el-option v-for="item in levelList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="16">
            <el-form-item label="年代 :">
              <el-cascader style="width: 100%;"
                :disabled="pageType === 'detail'" 
                v-model="year1" 
                :options="platOptions"
                @active-item-change="handleItemChange" 
                :props="props">
              </el-cascader>
            </el-form-item>
            <!-- <el-form-item label="年代 :" prop="sourceNumber">
              <el-input v-model="form.sourceNumber" placeholder="请输入"
                :disabled="pageType==='detail'" @change="handleChange"></el-input>
            </el-form-item> -->
          </el-col>

          <el-col :span="8">
            <el-form-item label="形态 :" prop="collectStyle">
              <el-select clearable v-model="form.collectStyle" placeholder="请选择">
                <el-option v-for="item in styleList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <!-- <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="文件todo :" prop="">
              <el-input v-model="detailData.collectTypeText" placeholder="自动获取"
                disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->

        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="概览 :" prop="overview">
              <div class="trans" v-html="form.overview" v-if="pageType === 'detail'"></div>
              <cmp-ckeditor v-else ref="myCkeditor1" :readOnly="pageType == 'detail'"
                :defaultMsg="form.overview" :id="`ck1`" :height="150"></cmp-ckeditor>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="作者小传 :" prop="author">
              <div class="trans" v-html="form.author" v-if="pageType === 'detail'"></div>
              <cmp-ckeditor v-else ref="myCkeditor2" :readOnly="pageType == 'detail'"
                :defaultMsg="form.author" :id="`ck2`" :height="150"></cmp-ckeditor>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="通长 :" prop="gsLength">
              <el-input v-model="form.gsLength" placeholder="请输入"
                :disabled="pageType==='detail'"></el-input>
            </el-form-item>

            <!-- <el-form-item label="藏品描述 :" prop="name">
              <el-input type="textarea" v-model="form.name" :disabled="pageType==='detail'"
                :placeholder="pageType  == 'detail'? '' : '请输入'"></el-input>
            </el-form-item> -->
          </el-col>

          <el-col :span="8">
            <el-form-item label="通宽 :" prop="gsHeight">
              <el-input v-model="form.gsHeight" placeholder="请输入"
                :disabled="pageType==='detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="排序值 :" prop="sequence">
              <el-input type="number" v-model="form.sequence" placeholder="请输入"
                :disabled="pageType==='detail'"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="流转经历 :">
              <div class="history-list">
                <div class="item" v-for="(item, index) in experienceList" :key="index">
                  <el-input v-model="item.name" placeholder="请输入" :disabled="pageType==='detail'"></el-input>

                  <div class="btn_dele" @click="deleExperience(item, index)">
                    删除
                  </div>
                </div>
                <div class="btn_add" @click="addExperience">
                  <i class="el-icon-plus"></i>
                  添加
                </div>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="藏品图片：">
              <el-upload ref="upload1" :file-list="fileList1" action="/singleMuseum/attach/upload"
                list-type="picture-card" :disabled="pageType == 'detail'" accept="image/*" :data="configData"
                :on-remove="(response, file, fileList) => { handleUnitPicRemove(response, file, '1') }"
                :on-success="(response, file, fileList) => { handleUnitPicSuccess(response, file, fileList, '1') }"
                :before-upload="beforeUnitPicUpload" multiple>
                <div class="img-uploader">
                  <i class="el-icon-plus"></i>
                  <span>上传藏品图片</span>
                </div>
                <div class="pic-list" slot="file" slot-scope="{file}">
                  <img :src="file.url" mode="heightFix" alt="" class="el-upload-list__item-thumbnail"
                    :ref='"file_" + file.uid'>
                  <span class="el-upload-list__item-actions">
                    <!-- <span class="el-upload-list__item-preview" @click="rotateImg(file, '2')"><i class="el-icon-refresh-left"></i></span> -->
                    <span class="el-upload-list__item-delete" @click="handleRemove(file, fileList1, '1')"><i class="el-icon-delete"></i></span>
                    <!-- <span class="el-upload-list__item-rotate" @click="rotateImg(file, '1')"><i class="el-icon-refresh-right"></i></span> -->
                  </span>
                </div>
              </el-upload>

            </el-form-item>

            <!-- <el-form-item label="卷轴图片 :">
              <div class="sch-box">
                <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" accept="image/*" :data="configData"
                  :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                  v-if="pageType!=='detail'">
                  <img v-if="imgUrl" style="height:150px;width:100%;object-fit:contain;" :src="imgUrl" class="avatar">
                  <div v-else>
                    <i class="el-icon-plus avatar-uploader-icon"></i>
                    <div class="el-upload__text">上传图片</div>
                  </div>
                </el-upload>
  
                <div class="pic-box" v-if="pageType==='detail'">
                  <img :src="imgUrl" alt="">
                </div>
              </div>
            </el-form-item> -->
          </el-col>
        </el-row>
        
        <!-- <el-form-item label="创建时间 :" prop="title">
          <el-date-picker style="width: 100%;" v-model="form.createTime" format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择时间"></el-date-picker>
        </el-form-item> -->
      </el-form>
    </div>

    <!-- 画心 -->
    <div class="wrap" v-show="activeTab==='2'">
      <el-form class="g-form-grid" ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="文字介绍 :" prop="content">
          <div class="trans" v-html="form.content" v-if="pageType === 'detail'"></div>
          <cmp-ckeditor v-else ref="myCkeditor3" :readOnly="pageType == 'detail'"
            :defaultMsg="form.content" :id="`ck1`" :height="150"></cmp-ckeditor>
        </el-form-item>

        <el-form-item label="书/画心图片 :">
          <div class="sch-box">
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" accept="image/*" :data="configData"
              :show-file-list="false" :on-success="handleAvatarSuccess2" :before-upload="beforeAvatarUpload2"
              v-if="pageType!=='detail'">
              <img v-if="imgUrl2" style="height:150px;width:100%;object-fit:contain;" :src="imgUrl2" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传图片</div>
              </div>
            </el-upload>

            <div class="pic-box" v-if="pageType==='detail'">
              <img :src="imgUrl2" alt="">
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <!-- 跋文 -->
    <div class="wrap" v-show="activeTab==='3'">
      <div class="com-list-content">
        <div class="button">
          <el-row>
            <el-button class="el-primary-border" round @click="handleAdd('', 'add')">
              <svg-icon icon-class="add" />&nbsp;添加
            </el-button>
          </el-row>
        </div>

        <div class="table mt-20">
          <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
            <el-table-column label="序号" width="50">
              <template slot-scope="scope">{{ scope.$index+1 }}</template>
            </el-table-column>

            <el-table-column label="图片" width="100">
              <template slot-scope="scope">
                <viewer :options="{ url: 'data-maxUrl' }">
                  <img class="g-pointer" :src="scope.row.imgUrl"
                    :data-maxUrl="scope.row.imgUrl" alt :onerror="defaultImg"
                    style="width: 50px;height: 30px;object-fit: contain;">
                </viewer>
              </template>
            </el-table-column>

            <el-table-column prop="name" label="标题" min-width="8%" show-overflow-tooltip></el-table-column>

            <el-table-column prop="content" label="内容" min-width="20%" show-overflow-tooltip></el-table-column>

            <el-table-column prop="sequence" label="排序" min-width="8%"></el-table-column>
  
            <!-- 操作 -->
            <el-table-column  fixed="right" label="操作" min-width="10%">
              <template slot-scope="scope">
                <a class="m-btn mr-10" @click="handleAdd(scope.row, 'detail')">详情</a>
                <a class="m-btn mr-10" @click="handleAdd(scope.row, 'edit')">编辑</a>
                <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
              </template>
            </el-table-column>
          </el-table>
  
          <div class="pagination-container paging">
            <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </div>
        </div>
      </div>
    </div>

    <!-- 印记 -->
    <div class="wrap" v-show="activeTab==='4'">
      <yinjiMap ref="yinjiMap"></yinjiMap>
    </div>

    <!-- 历代著录 -->
    <div class="wrap" v-show="activeTab==='5'">
      <div class="com-list-content">
        <div class="button">
          <el-row>
            <el-button class="el-primary-border" round @click="handleAdd('', 'add')">
              <svg-icon icon-class="add" />&nbsp;添加
            </el-button>
          </el-row>
        </div>

        <div class="table mt-20">
          <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
            <el-table-column label="序号" width="50">
              <template slot-scope="scope">{{ scope.$index+1 }}</template>
            </el-table-column>

            <el-table-column prop="name" label="标题" min-width="8%" show-overflow-tooltip></el-table-column>
            
            <el-table-column prop="author" label="作者" min-width="8%" show-overflow-tooltip></el-table-column>

            <el-table-column prop="content" label="文字" min-width="30%" show-overflow-tooltip></el-table-column>

            <el-table-column prop="sequence" label="排序" min-width="8%"></el-table-column>
  
            <!-- 操作 -->
            <el-table-column  fixed="right" label="操作" min-width="10%">
              <template slot-scope="scope">
                <a class="m-btn mr-10" @click="handleAdd(scope.row, 'detail')">详情</a>
                <a class="m-btn mr-10" @click="handleAdd(scope.row, 'edit')">编辑</a>
                <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
              </template>
            </el-table-column>
          </el-table>
  
          <div class="pagination-container paging">
            <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </div>
        </div>
      </div>
    </div>

    <!-- 图集 -->
    <div class="wrap" v-show="activeTab==='6'">
      <div class="com-list-content">
        <div class="button">
          <el-row>
            <el-button class="el-primary-border" round @click="handleAdd('', 'add')">
              <svg-icon icon-class="add" />&nbsp;添加
            </el-button>
          </el-row>
        </div>

        <div class="table mt-20">
          <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
            <el-table-column label="序号" width="50">
              <template slot-scope="scope">{{ scope.$index+1 }}</template>
            </el-table-column>

            <el-table-column label="图片" min-width="20%">
              <template slot-scope="scope">
                <viewer :options="{ url: 'data-maxUrl' }">
                  <img class="g-pointer" :src="scope.row.imgUrl"
                    :data-maxUrl="scope.row.imgUrl" alt :onerror="defaultImg"
                    style="width: 50px;height: 30px;object-fit: contain;">
                </viewer>
              </template>
            </el-table-column>

            <el-table-column prop="name" label="名称" min-width="20%" show-overflow-tooltip></el-table-column>

            <el-table-column prop="sequence" label="排序" min-width="8%"></el-table-column>

            <!-- 操作 -->
            <el-table-column  fixed="right" label="操作" min-width="10%">
              <template slot-scope="scope">
                <a class="m-btn mr-10" @click="handleAdd(scope.row, 'detail')">详情</a>
                <a class="m-btn mr-10" @click="handleAdd(scope.row, 'edit')">编辑</a>
                <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
              </template>
            </el-table-column>
          </el-table>

          <div class="pagination-container paging">
            <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
          </div>
        </div>
      </div>
    </div>

    <div slot="footer" class="footer fr mt-30" v-if="pageType!=='detail'">
      <el-button @click="goBack">返回</el-button>
      <el-button @click="fromSubmit('form')" type="primary" :loading="loadingSave">保存</el-button>
    </div>
    <div slot="footer" class="footer fr mt-30" v-if="pageType==='detail'">
      <el-button type="primary" @click="goBack">返回</el-button>
    </div>

    <dialogInfo ref="dialogInfo" @refresh="restList"></dialogInfo>
  </div>
</template>

<script>
import Sortable from 'sortablejs'

// import cmpUploadMainPhonto from '@cmp/my-upload/main-photo'
import { mapGetters } from 'vuex'
import cmpCkeditor from '@cmp/editor/ckeditor'
import dialogInfo from './dialog-info'
import yinjiMap from './yinji-map'
export default {
  // components: { cmpUploadMainPhonto },
  components: { cmpCkeditor, dialogInfo, yinjiMap },
  computed: {
    ...mapGetters(['imageTypes']),
  },
  data() {
    return {
      defaultImg: this.$store.state.app.defaultImg,
      activeTab: '1',
      tabList: [
        {
          name: '简介',
          value: '1'
        },
        {
          name: '书/画心',
          value: '2'
        },
        {
          name: '跋文',
          value: '3'
        },
        {
          name: '鉴藏印记',
          value: '4'
        },
        {
          name: '历代著录',
          value: '5'
        },
        {
          name: '图集',
          value: '6'
        },
      ],
      styleList: [
        // {
        //   dictName: '横轴',
        //   dictCode: '1'
        // },
        // {
        //   dictName: '竖轴',
        //   dictCode: '2'
        // },
        // {
        //   dictName: '册页',
        //   dictCode: '3'
        // },
      ],
      year1: '',
      platOptions: [],
      props: {
        label: 'dictName',
        value: 'dictCode',
        children: 'child',
        checkStrictly: true
      },
      listLoading: false,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      // historyList: [],

      fileList1: [],
      pictureIds: [],



      loadingSave: false,
      pageType: 'add', // 页面类型 add 新增  edit 编辑  detail 详情
      detailId: '', // 用户id
      form: {},
      typeList: [],
      levelList: [],
      experienceList: [{name: ''}, {name: ''}],

      dialogVisible: false,
      configData: {
        tableName: 'qgCollect'
      },
      imgUrl: '',
      imgUrl2: '',
      rules: {
        name: [{ required: true, message: '必填', trigger: 'blur' }],
        code: [{ required: true, message: '必填', trigger: 'blur' }],
        type: [{ required: true, message: '请选择', trigger: 'blur' }],
        sourceNumber: [{ required: true, message: '必填', trigger: 'blur' }],

        // scope: [
        //   { required: true, message: '必填', trigger: 'blur' },
        //   // { min: 1, max: 30, message: '请输入1到30个字符', trigger: 'blur' }
        // ],
        // title: [{ required: true, message: '必填', trigger: 'blur' }],
      },
      scopeList: [],
      detailData: {}
    }
  },
  methods: {
    changeTab(item) {
      this.activeTab = item.value

      console.log(this.activeTab)

      if(this.activeTab === '3' || this.activeTab === '5' || this.activeTab === '6') {
        this.restList()
      } else if(this.activeTab === '4') {
        this.$refs.yinjiMap.show(this.detailId)
      }
    },
    addExperience() {
      this.experienceList.push({name: ''})
    },
    deleExperience(item, index) {
      this.experienceList.splice(index, 1)
    },
    handleChange() {
      console.log(this.form.laiyuan)

      // 获取素材来源和年代 todo
      this.$http
        .get('/collection/getCollectionByCode', {
          code: this.form.sourceNumber
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.result
            // this.form = res.result
            // if (res.result.img) {
            //   this.imgUrl = res.result.imgUrl
            // }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    getData() {
      if(this.activeTab === '3') {
        this.getData1()
      } else if(this.activeTab === '5') {
        this.getData5()
      } else if(this.activeTab === '6') {
        this.getData6()
      }
    },
    getData1() {
      this.listLoading = true
      this.tableData = []
      this.$http.get('/qinggong/qgCollectPostscript/list', {
        collectId: this.detailId,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        this.listLoading = false
      })
    },
    getData5() {
      this.listLoading = true
      this.tableData = []
      this.$http.get('/qinggong/qgCollectBook/list', {
        collectId: this.detailId,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        this.listLoading = false
      })
    },
    getData6() {
      this.listLoading = true
      this.tableData = []
      this.$http.get('/qinggong/qgCollectAlbum/list', {
        collectId: this.detailId,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        this.listLoading = false
      })
    },
    // 重置查询
    restList() {
      // this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.getData()
    },
    // 获取下拉选项的值
    initSelect(id) {
      this.$http
        .post('/collectDict/getSelectDataByArr', {
          arr: [
            'collection_year',
            'collection_level',
            'qing_type',
            'qing_style',
          ]
        })
        .then((res) => {
          var success = res.success
          if (success) {
            var data = res.result
            this.typeList = data.qing_type
            this.levelList = data.collection_level
            this.styleList = data.qing_style
            this.platOptions = data.collection_year
            this.platOptions.map((item, index, array) => {
              // 因为数组和对象更新后不会更新视图，这里必须用$set方法
              this.$set(array[index], 'child', [])
            })

            // if (id) {
            //   this.getDetail(id)
            // }
          }
        })
    },

    initDragSort2() {
      // 支持拖拽排序
      const el = this.$refs.upload1.$el.querySelectorAll('.el-upload-list')[0]
      Sortable.create(el, {
        onEnd: ({ oldIndex, newIndex }) => {
          // 交换位置
          const arr = this.fileList1
          const page = arr[oldIndex]
          let tempIds = []
          arr.splice(oldIndex, 1)
          arr.splice(newIndex, 0, page)
          arr.map((item) => {
            if (item.response && item.response.result) {
              tempIds.push(item.response.result.attId)
            } else {
              if (item.url) {
                let tempUrl = item.url.split('=')
                let attId = tempUrl[1].split('&')[0]
                tempIds.push(attId)
              }
            }
          })


          console.log(111, tempIds)
          this.pictureIds = tempIds
        }
      })
    },

    handleUnitPicRemove(file, fileList, type) {
      console.log(fileList)
      if (type == 1) {
        this.pictureIds = []
      }
      if (fileList && fileList.length > 0) {
        fileList.map((item) => {
          if (item.response && item.response.result) {
            if (type == 1) {
              this.pictureIds.push(item.response.result.attId)
            }
          } else {
            // 修改状态
            if (item.url) {
              let arr = item.url.split('&'),
                arr1 = arr[0].split('=')

              if (type == 1) {
                this.pictureIds.push(arr1[1])
              }
            }
          }
        })
      }
    },

    // 上传团队图片
    beforeUnitPicUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 2MB!',
      //     type: 'warning'
      //   })
      //   return
      // }

      if (this.imageTypes.includes(fileType)) {
        return true
      } else {
        this.$message.error('请上传正确的图片类型')
        return
      }
    },

    handleUnitPicSuccess(res, file, fileList, type) {
      if (res.success) {
        this.$message.success('上传成功')
        if (type == 1) {
          this.fileList1 = fileList
          this.pictureIds.push(res.result.attId)
        }
      } else {
        let index = 0
        for (const i in fileList) {
          if (fileList[i] == file) {
            index = i
            break
          }
        }
        //移出当前文件对象
        fileList.splice(index, 1)
        this.$message.error(res.message)
      }
    },

    rotateImg(file, type) {
      if (!file.rotate) {
        this.$set(file, 'rotate', 0)
      }
      if (file.response && file.response.success) {
        if (file.response.result) {
          let attId = file.response.result.attId
          this.$http
            .get('/attach/rotatePicture', {
              id: attId,
              type: type
            })
            .then((res) => {
              if (res.success) {
                if (type == 1 || type == 3) {
                  file.rotate += 90
                }
                if (type == 2 || type == 4) {
                  file.rotate -= 90
                }
                this.$refs[
                  'file_' + file.uid
                ].style.transform = `rotate(${file.rotate}deg)`
                this.$message.success('旋转成功')
              }
            })
        }
      } else {
        var keyValue = file.url.split('=')
        var key = keyValue[0]
        var value = keyValue[1]

        if (value) {
          let keyValue1 = value.split('&'),
            attId = keyValue1[0]
          this.$http
            .get('/attach/rotatePicture', {
              id: attId,
              type: type
            })
            .then((res) => {
              if (res.success) {
                if (type == 1) {
                  file.rotate += 90
                } else {
                  file.rotate -= 90
                }
                this.$refs[
                  'file_' + file.uid
                ].style.transform = `rotate(${file.rotate}deg)`
                this.$message.success('旋转成功')
              }
            })
        }
      }
    },

    handleRemove(file, fileList, type) {
      let newList = fileList.filter((item) => {
        return item.uid != file.uid
      })

      if (type == 1) {
        this.pictureIds = []
        this.fileList1 = newList
      }
      if (newList && newList.length > 0) {
        newList.map((item) => {
          if (item.response && item.response.result) {
            if (type == 1) {
              this.pictureIds.push(item.response.result.attId)
            }
          } else {
            // 修改状态
            if (item.url) {
              let arr = item.url.split('&'),
                arr1 = arr[0].split('=')

              if (type == 1) {
                this.pictureIds.push(arr1[1])
              }
            }
          }
        })
      }
    },

    cascaderList(key1, key2) {
      this.platOptions.map((item, index) => {
        if (item.dictCode === key1) {
          // 当顶级分类的的child为空时才请求数据
          this.$http
            .post('/collectDict/getDictListByPid', { pid: key1 })
            .then((res) => {
              if (res.success) {
                this.$set(this.platOptions[index], 'child', res.result)
                item.child.map((innerItem, innerIndex) => {
                  // 二级分类下必须要设置一个空的child数组，不然点击@active-item-change没反应
                  this.$set(item.child[innerIndex], 'child', [])
                })

                if (key2) {
                  this.platOptions[index].child.map((it, dx) => {
                    if (it.dictCode === key2) {
                      this.$http
                        .post('/collectDict/getDictListByPid', { pid: key2 })
                        .then((res) => {
                          if (res.success) {
                            this.$set(it, 'child', res.result)
                          }
                        })
                    }
                  })
                }
              }
            })
        }
      })
    },
    handleItemChange(value) {
      // 动态/异步加载分类数据
      let parentId = ''
      // this.addForm.collectDetailYear = ''
      if (value.length === 1) {
        // 如果点击的是一级分类
        parentId = value[0]
        this.platOptions.map((item, index) => {
          if (item.dictCode === parentId && item.child.length === 0) {
            // 当顶级分类的的child为空时才请求数据
            this.$http
              .post('/collectDict/getDictListByPid', { pid: parentId })
              .then((res) => {
                if (res.success) {
                  this.$set(this.platOptions[index], 'child', res.result)
                  item.child.map((innerItem, innerIndex) => {
                    // 二级分类下必须要设置一个空的child数组，不然点击@active-item-change没反应
                    this.$set(item.child[innerIndex], 'child', [])
                  })
                }
              })
          }
        })
      } else {
        // 如果点击的是二级分类，则直接将三级分类绑定到platOptions
        parentId = value[1]
        this.platOptions.map((item, index) => {
          item.child.map((innerItem, innerIndex) => {
            if (
              innerItem.dictCode === parentId &&
              innerItem.child.length === 0
            ) {
              // 当二级分类的的child为空时才请求一次数据
              this.$http
                .post('/collectDict/getDictListByPid', { pid: parentId })
                .then((res) => {
                  if (res.success) {
                    this.$set(item.child[innerIndex], 'child', res.result)
                  }
                })
            }
          })
        })
      }
    },
    handleAdd(item, type) {
      console.log(item, type)
      let roleType = ''
      if(this.activeTab === '3') {
        roleType = 'bawen'
      } else if(this.activeTab === '5') {
        roleType = 'article'
      } else if(this.activeTab === '6') {
        roleType = 'photo'
      }
      this.$nextTick(() => {
        this.$refs.dialogInfo.init(item, type, this.detailId, roleType)
      })
    },
    // 删除
    handleDelete(item) {
      let apiUrl = ''
      if(this.activeTab === '3') {
        apiUrl = '/qinggong/qgCollectPostscript/delete'
      } else if(this.activeTab === '5') {
        apiUrl = '/qinggong/qgCollectBook/delete'
      } else if(this.activeTab === '6') {
        apiUrl = '/qinggong/qgCollectAlbum/delete'
      }
      this.$common.confirm(
        {
          content: '该数据将被删除，请谨慎操作'
        }, () => {
          this.$http
            .get(apiUrl, {
              id: item.id
            }).then(res => {
              if (res.success) {
                this.$message.success('素材删除成功')
                this.getData()
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },
    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData1()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData1()
    },

    handleSearch() {},
    // init(type, id) {
    //   this.dialogVisible = true
    //   // 清空弹框数据
    //   this.form = {}
    //   this.pageType = type // 页面类型
    //   this.detailId = id || '' // 详情id
    //   // 新增或编辑
    //   if (this.detailId) {
    //     this.getDetailData()
    //   }
    //   this.$nextTick(() => {
    //     this.$refs.myCkeditor.initEditor()
    //     this.$refs['form'].clearValidate() // 清空验证状态
    //   })
    // },

    // 获取详情
    getDetailData() {
      this.$http
        .get('/qinggong/qgCollect/find', {
          id: this.detailId
        })
        .then(res => {
          if (res.success) {
            let data = res.result

            if(data.experiences.length) {
              let arr = []
              data.experiences.forEach(item => {
                arr.push({name: item})
              })
              this.experienceList = arr
            }
            if (data.collectYear) {
              this.year1 = data.collectYear.split(',')
              if (this.year1.length > 0) {
                if (this.year1.length == 2) {
                  this.cascaderList(this.year1[0])
                }

                if (this.year1.length == 3) {
                  this.cascaderList(this.year1[0], this.year1[1])
                }
              }
            }

            if (data.imgUrls && data.imgUrls.length > 0) {
              data.imgUrls.map((item) => {
                this.fileList1.push({
                  name: item.attName,
                  url: item.attPath
                })
              })
              this.pictureIds = data.imgIds && data.imgIds.split(',') || []
            }
            
            this.form = data
            this.$nextTick(() => {
              // this.imgUrl = data.imgIds  // todo
              this.imgUrl2 = data.midImgUrl
            })
          } else {
            this.$message.error(res.message)
          }
        })
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 2MB!',
      //     type: 'warning'
      //   })
      //   return
      // }

      if (this.imageTypes.includes(fileType)) {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        if (this.pageType == 'edit') {
          this.form.imgUrl = res.result.attPath
        }
        this.form.attId = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    beforeAvatarUpload2(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 2MB!',
      //     type: 'warning'
      //   })
      //   return
      // }

      if (this.imageTypes.includes(fileType)) {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return
      }
    },

    handleAvatarSuccess2(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl2 = res.result.attPath
        // if (this.pageType == 'edit') {
        //   this.form.imgUrl2 = res.result.attPath
        // }
        this.form.midImg = res.result.attId
      } else {
        this.$message.error(res.message)
      }
    },

    // 文件上传回调
    uploadCallback(fileStr) {
      this.form.fileIds = fileStr
    },

    // 保存
    fromSubmit(form) {
      if(this.activeTab === '1' || this.activeTab === '2') {
        this.save1(form)
      } else if(this.activeTab === '4') {
        this.$refs.yinjiMap.save()
      }
    },
    save1(form) {
      let content1 = this.$refs.myCkeditor1.getContent() // 调用子组件方法
      let content2 = this.$refs.myCkeditor2.getContent() // 调用子组件方法
      let content3 = this.$refs.myCkeditor3.getContent() // 调用子组件方法
      // if (!content) {
      //   this.$message.warning('请输入内容')
      //   return
      // }
      // if(!this.form.attId) {
      //   this.$message.warning('请上传图片')
      //   return
      // }
      let experienceArr = this.experienceList.map(item => item.name)
      console.log(this.form)
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true
          // let apiUrl = `/collectmaterial/save`
          // if(this.pageType === 'edit') {
          //   apiUrl = `/collectmaterial/update`
          // }
          this.$http
            .post('/qinggong/qgCollect/update', {
              ...this.form,
              overview: content1,
              author: content2,
              content: content3, // 画心文字描述
              experiences: experienceArr,
              collectYear: this.year1.length > 0 ? this.year1.join(',') : '',
              imgIds: this.pictureIds.join(',')
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                if (this.pageType === 'edit') {
                  this.$message.success('编辑成功')
                } else if (this.pageType === 'add') {
                  this.$message.success('创建成功')
                }
                // this.goBack()

                // this.cancel()
                // this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },
    save3() {
      // let content = this.$refs.myCkeditor.getContent() // 调用子组件方法
      // if (!content) {
      //   this.$message.warning('请输入内容')
      //   return
      // }
      if(!this.form.attId) {
        this.$message.warning('请上传图片')
        return
      }
      this.$refs[form].validate(vaild => {
        if (vaild) {
          this.loadingSave = true

          let apiUrl = `/collectmaterial/save`
          if(this.pageType === 'edit') {
            apiUrl = `/collectmaterial/update`
          }
          this.$http
            .post(apiUrl, {
              ...this.form,
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                if (this.pageType === 'edit') {
                  this.$message.success('编辑成功')
                } else if (this.pageType === 'add') {
                  this.$message.success('创建成功')
                }
                this.goBack()

                this.cancel()
                this.$emit('refresh')
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        }
      })
    },

    goBack() {
      this.$router.go(-1)
    },

    // 取消
    cancel() {
      this.imgUrl = ""
      this.$refs['form'].resetFields()
      this.dialogVisible = false
    },

    handleBeforeClose(done) {
      this.imgUrl = ""
      this.$refs['form'].resetFields()
      // this.$refs.myCkeditor.setContent('')  // 处理编辑时偶尔不能渲染出富文本数据
      done()
    }
  },
  created() {
    this.initSelect()

    // this.dialogVisible = true
    // 清空弹框数据
    this.form = {}
    this.pageType = this.$route.query.pageType // 页面类型
    this.detailId = this.$route.query.id || '' // 详情id
    // 新增或编辑
    if (this.detailId) {
      this.getDetailData()
    }
    this.$nextTick(() => {
      // this.$refs.myCkeditor.initEditor()
      this.$refs['form'].clearValidate() // 清空验证状态

      this.initDragSort2()
    })
  }
}
</script>

<style lang="scss" scoped>
.page-qinggong-edit {
  width: 100%;
  padding: 50px 10%;
  box-sizing: border-box;
  background: #fff;
  overflow-y: auto;

  .img-uploader {
    cursor: pointer;
    height: 100%;
    line-height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .header {
    margin-bottom: 20px;
    // border-bottom: solid 1px #e5e5e5;
    h1 {
      margin-bottom: 10px;
    }
  }


  .tabs {
    padding-bottom: 10px;
    margin-bottom: 20px;
    display: flex;
    border-bottom: solid 1px #e5e5e5;
    .tab-item {
      margin-right: 30px;
      cursor: pointer;
      &.active {
        color: $primary;
      }
    }
  }

  .history-list {
    display: flex;
    flex-wrap: wrap;
    .item {
      position: relative;
      padding-right: 85px;
      margin-bottom: 10px;

      display: flex;
      align-items: center;

      &:hover {
        .btn_dele {
          display: block;
        }
      }
      &:after {
        content: '';
        display: block;
        width: 85px;
        height: 1px;
        background: #ececec;
        position: absolute;
        right: 0;
        top: 50%;
      }
      &:nth-last-child(2) {
        &:after {
          display: none;
        }
      }
    }
  }
  .btn_add {
    margin-left: -20px;
    color: $primary;
    font-size: 14px;
    cursor: pointer;
  }
  .btn_dele {
    margin-left: 10px;
    color: #f25151;
    font-size: 14px;
    cursor: pointer;
    white-space: nowrap;
    display: none;
    position: absolute;
    right: 60px;
    top: 50%;
    transform: translateY(-50%);
  }


  .sch-box {
    margin-bottom: 20px;

    .pic-box {
      text-align: center;
      margin-bottom: 30px;
      img {
        max-width: 60%;
      }
    }
  }
  .avatar-uploader {
    width: 50%;
    border: 1px dashed #8c939d;
    min-height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .el-upload {
      width: 100%;
      height: 150px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .el-icon-plus {
      font-size: 20px;
    }

    .el-upload__text {
      line-height: 1;
    }
  }

  .el-upload-list {
    .pic-list {
      width: 100%;
      height: 100%;
      .el-upload-list__item-thumbnail {
        object-fit: contain;
      }
    }
  }

  .res {
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: solid 1px #e5e5e5;
  }

  .wrap {
    
    
  }
}
</style>

